import React, { useState } from "react";

const ComplaintBox = () => {
  const [formData, setFormData] = useState({
    orderId: "",
    mobile: "",
    complaint: "",
    solution: "",
    refundNumber: "",
    productImage: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "productImage") {
      setFormData({ ...formData, productImage: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });
  };

  return (
    <div className="container mt-4" data-no-translate>
      <div className="card shadow p-4">
        <h4 className="mb-3">অভিযোগ / Complain Box</h4>

        <form onSubmit={handleSubmit}>
          {/* Order ID */}
          <div className="mb-3">
            <label className="form-label">১. অর্ডার আইডি</label>
            <input
              type="text"
              className="form-control"
              name="orderId"
              required
              onChange={handleChange}
            />
          </div>

          {/* Mobile */}
          <div className="mb-3">
            <label className="form-label">২. মোবাইল নাম্বার ( অর্ডারের সময় যে মোবাইল নাম্বারটি দিয়েছেন সেটি লিখুন।)</label>
            <input
              type="tel"
              className="form-control"
              name="mobile"
              required
              onChange={handleChange}
            />
          </div>

          {/* Complaint */}
          <div className="mb-3">
            <label className="form-label">
              ৩. আপনার অভিযোগ / সমস্যা / পরামর্শ
            </label>
            <textarea
              className="form-control"
              rows="4"
              name="complaint"
              required
              onChange={handleChange}
            ></textarea>
          </div>

          {/* Expected Solution */}
          <div className="mb-3">
            <label className="form-label">
              ৪. আপনি কি ধরনের সমাধান প্রত্যাশা করেন?
            </label>
            <select
              className="form-select"
              name="solution"
              required
              onChange={handleChange}
            >
              <option value="">-- নির্বাচন করুন --</option>
              <option value="replacement">পণ্য পরিবর্তন</option>
              <option value="refund">রিফান্ড</option>
              <option value="partial_refund">আংশিক রিফান্ড</option>
              <option value="support">সাপোর্ট প্রয়োজন</option>
            </select>
          </div>

          {/* Refund Number */}
          {formData.solution === "refund" && (
            <div className="mb-3">
              <label className="form-label">
                ৫. বিকাশ / নগদ নাম্বার
              </label>
              <input
                type="text"
                className="form-control"
                name="refundNumber"
                required
                onChange={handleChange}
              />
            </div>
          )}

          {/* Image Upload */}
          <div className="mb-3">
            <label className="form-label">
              ৬. ভুল / ড্যামেজড পণ্যের ছবি
            </label>
            <input
              type="file"
              className="form-control"
              name="productImage"
              accept="image/*"
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="btn btn-primary w-100">
            অভিযোগ জমা দিন
          </button>
        </form>
      </div>
    </div>
  );
};

export default ComplaintBox;
